import { create } from "zustand"

interface SessionNoShowModalStore {
  isOpen: boolean
  onClose: () => void
  onOpen: (sessionBookingId: number) => void
  sessionBookingId: number | null
}

export const useSessionNoShowModalStore = create<SessionNoShowModalStore>()(
  (set) => ({
    isOpen: false,
    onClose: () => set({ isOpen: false }),
    onOpen: (sessionBookingId) => set({ isOpen: true, sessionBookingId }),
    sessionBookingId: null,
  })
)
